// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__cqlwA","title":"AfterImages90_title__3CyZd","images":"AfterImages90_images__2BX5t"};